import { createFileRoute, redirect } from '@tanstack/react-router';

import { ServiceChannelMappings } from '../modules/ServiceChannelMappings';
import { serviceChannelAdminCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/admin/servicechannel-mappings')({
  component: RouteComponent,
  // These mappings decide which department, priority and status ServiceChannel
  // work lands under. A wrong entry does not error — it silently misfiles real
  // commercial work — so the route carries a gate as well as every RPC behind
  // it, and the redirect goes somewhere the user can actually use.
  loader(ctx) {
    if (!serviceChannelAdminCheck(ctx.context.authContext.user)) {
      throw redirect({ to: '/commercial-service-queue' });
    }
  },
  head() {
    return {
      meta: [{ title: 'ServiceChannel Mappings' }],
    };
  },
});

function RouteComponent() {
  return <ServiceChannelMappings />;
}
